import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check_icon--sprite",
  "use": "check_icon--sprite-usage",
  "viewBox": "0 0 18 14",
  "content": "<symbol viewBox=\"0 0 18 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check_icon--sprite\">\n    <path d=\"M17.5 1.41L5.5 13.41L0 7.91L1.41 6.5L5.5 10.58L16.09 0L17.5 1.41Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol